(function () {
  var MOBILE_MQ = window.matchMedia("(max-width: 767px)");

  function initTabs(root) {
    if (root.dataset.tabsInit === "1") return;
    root.dataset.tabsInit = "1";

    var navList = root.querySelector("[data-tabs-nav-list]");
    var content = root.querySelector("[data-tabs-content]");
    var select = root.querySelector("[data-tabs-select]");
    var mobileDropdownEnabled =
      root.dataset.mobileDropdown === "true" ||
      root.classList.contains("product-info-tabs--mobile-dropdown");
    if (!navList || !content) return;

    // Move each tab button (rendered inside content_for 'blocks') into the nav bar.
    // Nested block settings can't be read from the parent, so each tab self-renders
    // its button + panel; here we just relocate the buttons.
    var items = content.querySelectorAll("[data-product-info-tab-item]");
    items.forEach(function (li) {
      navList.appendChild(li);
    });

    var buttons = Array.prototype.slice.call(
      navList.querySelectorAll("[data-product-info-tab]")
    );
    var panels = Array.prototype.slice.call(
      content.querySelectorAll("[data-product-info-tab-panel]")
    );
    if (!buttons.length) {
      root.classList.add("tabs-ready");
      return;
    }

    function useDropdownNav() {
      return mobileDropdownEnabled && MOBILE_MQ.matches;
    }

    function activate(id, options) {
      options = options || {};
      buttons.forEach(function (b) {
        b.setAttribute(
          "aria-selected",
          b.dataset.blockId === id ? "true" : "false"
        );
        b.tabIndex = b.dataset.blockId === id ? 0 : -1;
      });
      panels.forEach(function (p) {
        p.classList.toggle("is-active", p.dataset.blockId === id);
      });

      if (mobileDropdownEnabled && select) {
        select.value = id;
      }

      if (useDropdownNav()) return;
      // Skip on init — scrollIntoView({ block: "nearest" }) scrolls the window
      // and lands the PDP mid-page (e.g. accessories above the tabs).
      if (options.scrollNav === false) return;

      var activeBtn = navList.querySelector(
        '[data-product-info-tab][data-block-id="' + id + '"]'
      );
      if (activeBtn && typeof activeBtn.scrollIntoView === "function") {
        activeBtn.scrollIntoView({
          behavior: "smooth",
          inline: "center",
          block: "nearest",
        });
      }
    }

    if (mobileDropdownEnabled && select) {
      select.innerHTML = "";
      buttons.forEach(function (b) {
        var option = document.createElement("option");
        option.value = b.dataset.blockId;
        option.textContent = b.textContent.trim();
        select.appendChild(option);
      });
      select.addEventListener("change", function () {
        activate(select.value);
      });
    }

    buttons.forEach(function (b) {
      b.addEventListener("click", function () {
        activate(b.dataset.blockId);
      });
      b.addEventListener("keydown", function (e) {
        if (e.key === "Enter" || e.key === " ") {
          e.preventDefault();
          activate(b.dataset.blockId);
        }
      });
    });

    root.classList.add("tabs-ready");
    activate(buttons[0].dataset.blockId, { scrollNav: false });

    // Theme editor: activate the tab the merchant selects.
    if (window.Shopify && Shopify.designMode) {
      var sectionId = root.dataset.sectionId;
      document.addEventListener("shopify:block:select", function (e) {
        if (e.detail && String(e.detail.sectionId) === String(sectionId)) {
          activate(e.detail.blockId);
        }
      });
    }
  }

  function run() {
    document.querySelectorAll("[data-tabs-root]").forEach(initTabs);
  }

  if (document.readyState !== "loading") {
    run();
  } else {
    document.addEventListener("DOMContentLoaded", run);
  }

  // Re-run when a section is re-rendered in the theme editor.
  document.addEventListener("shopify:section:load", run);
})();
